// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.content-req #btn-resend {
    border-radius: 25px;
    min-width: 130px;
}

.content-req#content-req-resend {
    text-align: center;
    margin-top: 15px;
}

#content-req-file img {
    max-height: 100px;
    border-radius: 8px;
    border: 1px solid #26a69a;
}
.content-req .PD, .content-req .RQ, .content-req .OK {
    color: #fb8c00;
}
.content-req .CC {
    color: #f23030;
}
.content-req .RJ {
    color: #f23030;
}
.content-req .AP {
    color: #6ed8bd;
}
#table-content .pagination li.active {
    background-color: #26a69a !important;
}
.content-req .file-upload .file-path {
    height: 36px;
    width: 100%;
    line-height: 35px;
    font-size: 12px;
}
.content-req .file-upload .btn-upload {
    background: #fff;
    color: #26a69a;
    border: 2px solid #26a69a;
    border-radius: 15px;
    height: 36px;
    line-height: 33px;
}
.content-req .desc-2 {
    padding-left: 0px;
}
.content-req .dropdown-content li>a, .content-req .dropdown-content li>span {
    font-size: 14px;
    line-height: 17px;
    padding: 9px 16px;
}
.content-req .dropdown-content li {
    min-height: 34px;
}
.content-req .select-wrapper input.select-dropdown {
    height: 100%;
    width: 100%;
    font-size: 14px;
}
.content-req input[type=date], .content-req input[type=time] {
    padding: 0px;
    height: 33px;
    min-height: auto;
    font-size: 14px;
}
.content-req .input-field {
    padding: 0px;
}
.inp-req {
    height: 33px;
    padding: 5px 0px;
    min-height: auto;
    font-size: 14px;
}
.inp-title {
    padding-top: 5px;
    line-height: 18px;
    min-height: 33px;
    height: auto;
    font-size: 14px;
}
#inp-req-reason {
    height: 30px;
    padding: 5px 0px;
    min-height: auto;
    font-size: 14px;
}
#content-req-user .error {
    color: red;
    font-size: 12px;
    margin-top: 8px;
    display: block;
    line-height: 15px;
}
#content-req-user .name {
    display: block;
}
#content-req-reason .title {
    padding-top: 5px;
}
#content-req-reason .input-field {
    padding: 0px;
} 
.image-circle i {
    font-size: 42px;
    margin-top: 8px;
    margin-left: 8px;
}
.image-circle {
    border-radius: 50%;
    display: block;
    height: 60px;
    width: 60px;
    border: 1px solid #ddd;
    margin-left: 8px;
}
#content-req-user .desc {
    margin-top: 12px;
}
#content-req-user {
    height: 60px;
    margin-bottom: 15px;
}
/*#modal-user-view .modal-content-outer {
    position: absolute;
    height: calc(100% - 45px);
    max-height: 100%;
    width: 100%;
    top: 45px;
    overflow-y: auto;
}
#modal-user-view .modal-content-inner {
    padding: 15px 25px;
}
#modal-user-view .modal-content h4 {
    top: 0px;
    margin: 0;
    font-size: 1.3rem;
    padding: 0 25px;
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
}*/
#modal-warning-content {
    position: relative;
}
#modal-warning-content i {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 3.2rem;
    color: #fed62b;
}
#modal-warning-content .text {
    color: #c01616;
    margin-left: 60px;
    font-size: 18px;
    padding-top: 5px;
}
#modal-error-content {
    position: relative;
}
#modal-error-content a {
    position: absolute;
    top: 0;
    left: 0;
}
#modal-error-content .text {
    color: #c01616;
    margin-left: 60px;
    font-size: 18px;
    padding-top: 5px;
}
#modal-done-content {
    position: relative;
}
#modal-done-content a {
    position: absolute;
    top: 0;
    left: 0;
}
#modal-done-content .text {
    color: #26a69a;
    margin-left: 60px;
    font-size: 18px;
    padding-top: 5px;
}
.modal-user .modal-footer-bottom-2 .btn-right-2 {
    padding-left: 8px;
    padding-right: 8px;
    text-transform: none;
    margin: 0;
    margin-left: 8px;
}
.modal-user .modal-footer-bottom-2 .btn-right-1 {
    padding-left: 8px;
    padding-right: 8px;
    text-transform: none;
}
.modal-user .modal-footer-bottom-2 .btn-right {
    float: right;
    margin-top: 7px;
}
.modal-user .modal-footer-bottom .modal-error-text {
    padding-top: 7px;
    font-weight: normal;
    font-size: 13px;
    line-height: 14px;
    display: block;
    margin-right: 90px;
}
.modal-user .modal-footer-bottom button {
    height: 30px;
    line-height: 30px;
    font-size: 1rem;
    position: absolute;
    top: 10px;
    right: 30px;
}
.modal-user .modal-footer-bottom, .modal-user .modal-footer-bottom-2 {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 50px;
    padding: 0px 25px;
    border-top: 1px solid rgba(0,0,0,0.1);
}
.modal-user-footer .text-error {
    padding: 25px;
}
.modal-user-footer .modal-content {
    padding: 0px;
}
.modal-user .modal-content-outer {
    position: absolute;
    height: calc(100% - 50px);
    width: 100%;
    bottom: 50px;
    overflow-y: auto;
    padding: 15px 25px;
}
.modal-close i {
    font-size: 2rem;
}
.modal-user .modal-content h4 {
    display: none;
}
.modal-user .modal-footer .header {
    font-size: 1.3rem;
    padding: 0 25px;
    height: 50px;
    line-height: 50px;
    float: left;
    text-transform: uppercase;
    font-weight: 600;
}
.modal-user .modal-close {
    margin: 8px 0px;
}
.modal-user .modal-content {
    position: absolute;
    height: calc(100% - 50px);
    max-height: 100%;
    width: 100%;
    top: 50px;
    overflow-y: auto;
}
.modal-user .modal-footer {
    position: absolute;
    top: 0;
    height: 50px;
    padding: 0px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
}
.modal-user {
    max-width: 480px;
    border-radius: 16px;
    height: 70%;
    /*height: 50% !important;*/
    border: 3px solid #37bdb0;
    max-height: 500px;
}
.content-req .title, .content-req .desc {
    line-height: 18px;
    min-height: 33px;
    height: auto;
}
.text-error {
    color: red;
    font-size: 14px;
}
#table-total {
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    margin-bottom: 20px;
}
#table-leave-summary .btn-check i,
.table-leave .btn-check i
 {
    font-size: 2rem;
}
#table-leave-summary .btn-delete i,
.table-leave .btn-delete i {
    font-size: 2.2rem;
}
#table-leave-summary .btn-delete,
.table-leave .btn-delete {
    display: inline-block;
    padding-left: 7px;
    padding-right: 7px;
}
#table-leave-summary .btn-edit i,
.table-leave .btn-edit i {
    font-size: 2rem;
}
#table-leave-summary .btn-edit,
.table-leave .btn-edit {
    display: inline-block;
    padding-left: 7px;
    padding-right: 7px;
}
#table-leave-summary .btn-view i,
.table-leave .btn-view i {
    margin-top: 2px;
    margin-bottom: 2px;
    font-size: 24px;
    line-height: unset;
    display: inline;
    color: #fff;
}
#table-leave-summary .btn-view,
.table-leave .btn-view {
    border: 1px solid #ddd;
    border-radius: 5px;
    display: inline-block;
    margin: 0 auto;
    padding: 0px 5px;
    background: #4f4949;
    height: 35px;
}
#table-leave-summary .OK,
.table-leave .OK {
    border: 2px solid #fb8c00;
    background-color: #fb8c00;
    color: #fff;
}
#table-leave-summary .PD, 
#table-leave-summary .RQ,
.table-leave .PD, 
.table-leave .RQ {
    border: 2px solid #fb8c00;
    background-color: #fff;
    color: #fb8c00;
}
#table-leave-summary .CC,
.table-leave .CC {
    border: 2px solid #f23030;
    background-color: #fff;
    color: #f23030;
}
#table-leave-summary .RJ,
.table-leave .RJ {
    border: 2px solid #f23030;
    background-color: #f23030;
    color: #fff;
}
#table-leave-summary .AP,
.table-leave .AP {
    border: 2px solid #6ed8bd;
    background-color: #6ed8bd;
    color: #fff;
}
#table-leave-summary .status-text,
.table-leave .status-text {
    border-radius: 12px;
    padding: 2px 0px;
    font-size: 13px;
    font-weight: 500;
    max-width: 110px;
    margin: 0 auto;
}
#table-leave-summary .total,
.table-leave .total {
    color: #20a684;
}
#table-leave-summary .small-text,
.table-leave .small-text {
    display: block;
    font-size: 11px;
    color: #20a684;
}
#table-leave-summary .text,
.table-leave .text {
    display: block;
    font-size: 13px;
}
#table-leave-summary th, #table-leave-summary td,
.table-leave th, .table-leave td {
    text-align: center;
    vertical-align: top;
}
#main-content .title {
    text-transform: uppercase;
    font-size: 18px;
    font-weight: bold;
}
#main-content {
    padding: 15px 20px;
}
.top-sub-bottom #btn-request-compensation {
    float: right;
    background: #fff;
    border: 2px solid #26a69a;
    color: #26a69a;
    text-transform: none;
    line-height: 30px;
    padding-left: 8px;
    padding-right: 8px;
    margin-left: 12px;
}
.top-sub-bottom #btn-create-new {
    float: right;
    text-transform: none;
    line-height: 30px;
    padding-left: 8px;
    padding-right: 8px;
    margin-left: 0px;
}
.top-sub-bottom div:nth-child(2) {
    float: left;
    margin-right: 15px;
    line-height: 36px;
}
.top-sub-bottom div:nth-child(1) {
    float: left;
    margin-right: 15px;
    line-height: 36px;
}
.top-sub-bottom .title{
    font-weight: bold;
    margin-right: 5px;
}
.top-sub-bottom {
    padding: 0px 20px;
}
#top-sub-box-compensation {
    background-color: #f1eee5;
}
#top-sub-box-balance {
    background-color: #F2F0D5;
}
#top-sub-box-previous {
    background-color:#ffd862;
}
#top-sub-box-annual {
    background-color:#A6BF4B;
}

.top-sub-box .color-red {
    color: #d40e0e;
}

.top-sub-box #top-sub-box-balance .text-day .sub-title,
.top-sub-box #top-sub-box-annual .text-day .sub-title,
.top-sub-box #top-sub-box-previous .text-day .sub-title {
    display: inline-block;
}

.top-sub-box #top-sub-box-balance .text-hour .sub-title,
.top-sub-box #top-sub-box-annual .text-hour .sub-title,
.top-sub-box #top-sub-box-previous .text-hour .sub-title {
    display: inline-block;
}

.top-sub-box .desc {
    padding: 8px 0px;
    font-size: 11px;
}
.top-sub-box .text-hour {
    font-size: 11px;
    margin-top: -6px;
    height: 15px;
}
.top-sub-box .text-day {
    font-size: 20px;
    font-weight: bold;
}
.top-sub-box span {
    display: block;
}
.top-sub-box .textcolor-expired {
    color: #e40d0d;
}
.top-sub-box .textcolor {
    color: #000;
}
.top-sub-box div {
    padding-top: 15px;
    padding-bottom: 5px;
    text-align: center;
    border-radius: 12px;
    margin: 0px;
}

.btn {
    text-transform: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Container/style.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA;;;;;;;;;;;;;;;;;;;EAmBE;AACF;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qCAAqC;AACzC;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,wCAAwC;AAC5C;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,UAAU;IACV,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;;;IAGI,eAAe;AACnB;AACA;;IAEI,iBAAiB;AACrB;AACA;;IAEI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;;IAEI,eAAe;AACnB;AACA;;IAEI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;;IAEI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;AACA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;AACA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;;;;IAII,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;AACA;;IAEI,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;AAClB;AACA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;;IAEI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;AACA;;IAEI,cAAc;AAClB;AACA;;IAEI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;AACA;;IAEI,cAAc;IACd,eAAe;AACnB;AACA;;IAEI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC","sourcesContent":["\r\n.content-req #btn-resend {\r\n    border-radius: 25px;\r\n    min-width: 130px;\r\n}\r\n\r\n.content-req#content-req-resend {\r\n    text-align: center;\r\n    margin-top: 15px;\r\n}\r\n\r\n#content-req-file img {\r\n    max-height: 100px;\r\n    border-radius: 8px;\r\n    border: 1px solid #26a69a;\r\n}\r\n.content-req .PD, .content-req .RQ, .content-req .OK {\r\n    color: #fb8c00;\r\n}\r\n.content-req .CC {\r\n    color: #f23030;\r\n}\r\n.content-req .RJ {\r\n    color: #f23030;\r\n}\r\n.content-req .AP {\r\n    color: #6ed8bd;\r\n}\r\n#table-content .pagination li.active {\r\n    background-color: #26a69a !important;\r\n}\r\n.content-req .file-upload .file-path {\r\n    height: 36px;\r\n    width: 100%;\r\n    line-height: 35px;\r\n    font-size: 12px;\r\n}\r\n.content-req .file-upload .btn-upload {\r\n    background: #fff;\r\n    color: #26a69a;\r\n    border: 2px solid #26a69a;\r\n    border-radius: 15px;\r\n    height: 36px;\r\n    line-height: 33px;\r\n}\r\n.content-req .desc-2 {\r\n    padding-left: 0px;\r\n}\r\n.content-req .dropdown-content li>a, .content-req .dropdown-content li>span {\r\n    font-size: 14px;\r\n    line-height: 17px;\r\n    padding: 9px 16px;\r\n}\r\n.content-req .dropdown-content li {\r\n    min-height: 34px;\r\n}\r\n.content-req .select-wrapper input.select-dropdown {\r\n    height: 100%;\r\n    width: 100%;\r\n    font-size: 14px;\r\n}\r\n.content-req input[type=date], .content-req input[type=time] {\r\n    padding: 0px;\r\n    height: 33px;\r\n    min-height: auto;\r\n    font-size: 14px;\r\n}\r\n.content-req .input-field {\r\n    padding: 0px;\r\n}\r\n.inp-req {\r\n    height: 33px;\r\n    padding: 5px 0px;\r\n    min-height: auto;\r\n    font-size: 14px;\r\n}\r\n.inp-title {\r\n    padding-top: 5px;\r\n    line-height: 18px;\r\n    min-height: 33px;\r\n    height: auto;\r\n    font-size: 14px;\r\n}\r\n#inp-req-reason {\r\n    height: 30px;\r\n    padding: 5px 0px;\r\n    min-height: auto;\r\n    font-size: 14px;\r\n}\r\n#content-req-user .error {\r\n    color: red;\r\n    font-size: 12px;\r\n    margin-top: 8px;\r\n    display: block;\r\n    line-height: 15px;\r\n}\r\n#content-req-user .name {\r\n    display: block;\r\n}\r\n#content-req-reason .title {\r\n    padding-top: 5px;\r\n}\r\n#content-req-reason .input-field {\r\n    padding: 0px;\r\n} \r\n.image-circle i {\r\n    font-size: 42px;\r\n    margin-top: 8px;\r\n    margin-left: 8px;\r\n}\r\n.image-circle {\r\n    border-radius: 50%;\r\n    display: block;\r\n    height: 60px;\r\n    width: 60px;\r\n    border: 1px solid #ddd;\r\n    margin-left: 8px;\r\n}\r\n#content-req-user .desc {\r\n    margin-top: 12px;\r\n}\r\n#content-req-user {\r\n    height: 60px;\r\n    margin-bottom: 15px;\r\n}\r\n/*#modal-user-view .modal-content-outer {\r\n    position: absolute;\r\n    height: calc(100% - 45px);\r\n    max-height: 100%;\r\n    width: 100%;\r\n    top: 45px;\r\n    overflow-y: auto;\r\n}\r\n#modal-user-view .modal-content-inner {\r\n    padding: 15px 25px;\r\n}\r\n#modal-user-view .modal-content h4 {\r\n    top: 0px;\r\n    margin: 0;\r\n    font-size: 1.3rem;\r\n    padding: 0 25px;\r\n    height: 45px;\r\n    line-height: 45px;\r\n    border-bottom: 1px solid rgba(0,0,0,0.1);\r\n}*/\r\n#modal-warning-content {\r\n    position: relative;\r\n}\r\n#modal-warning-content i {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    font-size: 3.2rem;\r\n    color: #fed62b;\r\n}\r\n#modal-warning-content .text {\r\n    color: #c01616;\r\n    margin-left: 60px;\r\n    font-size: 18px;\r\n    padding-top: 5px;\r\n}\r\n#modal-error-content {\r\n    position: relative;\r\n}\r\n#modal-error-content a {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n}\r\n#modal-error-content .text {\r\n    color: #c01616;\r\n    margin-left: 60px;\r\n    font-size: 18px;\r\n    padding-top: 5px;\r\n}\r\n#modal-done-content {\r\n    position: relative;\r\n}\r\n#modal-done-content a {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n}\r\n#modal-done-content .text {\r\n    color: #26a69a;\r\n    margin-left: 60px;\r\n    font-size: 18px;\r\n    padding-top: 5px;\r\n}\r\n.modal-user .modal-footer-bottom-2 .btn-right-2 {\r\n    padding-left: 8px;\r\n    padding-right: 8px;\r\n    text-transform: none;\r\n    margin: 0;\r\n    margin-left: 8px;\r\n}\r\n.modal-user .modal-footer-bottom-2 .btn-right-1 {\r\n    padding-left: 8px;\r\n    padding-right: 8px;\r\n    text-transform: none;\r\n}\r\n.modal-user .modal-footer-bottom-2 .btn-right {\r\n    float: right;\r\n    margin-top: 7px;\r\n}\r\n.modal-user .modal-footer-bottom .modal-error-text {\r\n    padding-top: 7px;\r\n    font-weight: normal;\r\n    font-size: 13px;\r\n    line-height: 14px;\r\n    display: block;\r\n    margin-right: 90px;\r\n}\r\n.modal-user .modal-footer-bottom button {\r\n    height: 30px;\r\n    line-height: 30px;\r\n    font-size: 1rem;\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 30px;\r\n}\r\n.modal-user .modal-footer-bottom, .modal-user .modal-footer-bottom-2 {\r\n    position: absolute;\r\n    bottom: 0px;\r\n    width: 100%;\r\n    height: 50px;\r\n    padding: 0px 25px;\r\n    border-top: 1px solid rgba(0,0,0,0.1);\r\n}\r\n.modal-user-footer .text-error {\r\n    padding: 25px;\r\n}\r\n.modal-user-footer .modal-content {\r\n    padding: 0px;\r\n}\r\n.modal-user .modal-content-outer {\r\n    position: absolute;\r\n    height: calc(100% - 50px);\r\n    width: 100%;\r\n    bottom: 50px;\r\n    overflow-y: auto;\r\n    padding: 15px 25px;\r\n}\r\n.modal-close i {\r\n    font-size: 2rem;\r\n}\r\n.modal-user .modal-content h4 {\r\n    display: none;\r\n}\r\n.modal-user .modal-footer .header {\r\n    font-size: 1.3rem;\r\n    padding: 0 25px;\r\n    height: 50px;\r\n    line-height: 50px;\r\n    float: left;\r\n    text-transform: uppercase;\r\n    font-weight: 600;\r\n}\r\n.modal-user .modal-close {\r\n    margin: 8px 0px;\r\n}\r\n.modal-user .modal-content {\r\n    position: absolute;\r\n    height: calc(100% - 50px);\r\n    max-height: 100%;\r\n    width: 100%;\r\n    top: 50px;\r\n    overflow-y: auto;\r\n}\r\n.modal-user .modal-footer {\r\n    position: absolute;\r\n    top: 0;\r\n    height: 50px;\r\n    padding: 0px;\r\n    border-bottom: 1px solid rgba(0,0,0,0.1);\r\n}\r\n.modal-user {\r\n    max-width: 480px;\r\n    border-radius: 16px;\r\n    height: 70%;\r\n    /*height: 50% !important;*/\r\n    border: 3px solid #37bdb0;\r\n    max-height: 500px;\r\n}\r\n.content-req .title, .content-req .desc {\r\n    line-height: 18px;\r\n    min-height: 33px;\r\n    height: auto;\r\n}\r\n.text-error {\r\n    color: red;\r\n    font-size: 14px;\r\n}\r\n#table-total {\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    text-transform: uppercase;\r\n    margin-bottom: 20px;\r\n}\r\n#table-leave-summary .btn-check i,\r\n.table-leave .btn-check i\r\n {\r\n    font-size: 2rem;\r\n}\r\n#table-leave-summary .btn-delete i,\r\n.table-leave .btn-delete i {\r\n    font-size: 2.2rem;\r\n}\r\n#table-leave-summary .btn-delete,\r\n.table-leave .btn-delete {\r\n    display: inline-block;\r\n    padding-left: 7px;\r\n    padding-right: 7px;\r\n}\r\n#table-leave-summary .btn-edit i,\r\n.table-leave .btn-edit i {\r\n    font-size: 2rem;\r\n}\r\n#table-leave-summary .btn-edit,\r\n.table-leave .btn-edit {\r\n    display: inline-block;\r\n    padding-left: 7px;\r\n    padding-right: 7px;\r\n}\r\n#table-leave-summary .btn-view i,\r\n.table-leave .btn-view i {\r\n    margin-top: 2px;\r\n    margin-bottom: 2px;\r\n    font-size: 24px;\r\n    line-height: unset;\r\n    display: inline;\r\n    color: #fff;\r\n}\r\n#table-leave-summary .btn-view,\r\n.table-leave .btn-view {\r\n    border: 1px solid #ddd;\r\n    border-radius: 5px;\r\n    display: inline-block;\r\n    margin: 0 auto;\r\n    padding: 0px 5px;\r\n    background: #4f4949;\r\n    height: 35px;\r\n}\r\n#table-leave-summary .OK,\r\n.table-leave .OK {\r\n    border: 2px solid #fb8c00;\r\n    background-color: #fb8c00;\r\n    color: #fff;\r\n}\r\n#table-leave-summary .PD, \r\n#table-leave-summary .RQ,\r\n.table-leave .PD, \r\n.table-leave .RQ {\r\n    border: 2px solid #fb8c00;\r\n    background-color: #fff;\r\n    color: #fb8c00;\r\n}\r\n#table-leave-summary .CC,\r\n.table-leave .CC {\r\n    border: 2px solid #f23030;\r\n    background-color: #fff;\r\n    color: #f23030;\r\n}\r\n#table-leave-summary .RJ,\r\n.table-leave .RJ {\r\n    border: 2px solid #f23030;\r\n    background-color: #f23030;\r\n    color: #fff;\r\n}\r\n#table-leave-summary .AP,\r\n.table-leave .AP {\r\n    border: 2px solid #6ed8bd;\r\n    background-color: #6ed8bd;\r\n    color: #fff;\r\n}\r\n#table-leave-summary .status-text,\r\n.table-leave .status-text {\r\n    border-radius: 12px;\r\n    padding: 2px 0px;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    max-width: 110px;\r\n    margin: 0 auto;\r\n}\r\n#table-leave-summary .total,\r\n.table-leave .total {\r\n    color: #20a684;\r\n}\r\n#table-leave-summary .small-text,\r\n.table-leave .small-text {\r\n    display: block;\r\n    font-size: 11px;\r\n    color: #20a684;\r\n}\r\n#table-leave-summary .text,\r\n.table-leave .text {\r\n    display: block;\r\n    font-size: 13px;\r\n}\r\n#table-leave-summary th, #table-leave-summary td,\r\n.table-leave th, .table-leave td {\r\n    text-align: center;\r\n    vertical-align: top;\r\n}\r\n#main-content .title {\r\n    text-transform: uppercase;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n}\r\n#main-content {\r\n    padding: 15px 20px;\r\n}\r\n.top-sub-bottom #btn-request-compensation {\r\n    float: right;\r\n    background: #fff;\r\n    border: 2px solid #26a69a;\r\n    color: #26a69a;\r\n    text-transform: none;\r\n    line-height: 30px;\r\n    padding-left: 8px;\r\n    padding-right: 8px;\r\n    margin-left: 12px;\r\n}\r\n.top-sub-bottom #btn-create-new {\r\n    float: right;\r\n    text-transform: none;\r\n    line-height: 30px;\r\n    padding-left: 8px;\r\n    padding-right: 8px;\r\n    margin-left: 0px;\r\n}\r\n.top-sub-bottom div:nth-child(2) {\r\n    float: left;\r\n    margin-right: 15px;\r\n    line-height: 36px;\r\n}\r\n.top-sub-bottom div:nth-child(1) {\r\n    float: left;\r\n    margin-right: 15px;\r\n    line-height: 36px;\r\n}\r\n.top-sub-bottom .title{\r\n    font-weight: bold;\r\n    margin-right: 5px;\r\n}\r\n.top-sub-bottom {\r\n    padding: 0px 20px;\r\n}\r\n#top-sub-box-compensation {\r\n    background-color: #f1eee5;\r\n}\r\n#top-sub-box-balance {\r\n    background-color: #F2F0D5;\r\n}\r\n#top-sub-box-previous {\r\n    background-color:#ffd862;\r\n}\r\n#top-sub-box-annual {\r\n    background-color:#A6BF4B;\r\n}\r\n\r\n.top-sub-box .color-red {\r\n    color: #d40e0e;\r\n}\r\n\r\n.top-sub-box #top-sub-box-balance .text-day .sub-title,\r\n.top-sub-box #top-sub-box-annual .text-day .sub-title,\r\n.top-sub-box #top-sub-box-previous .text-day .sub-title {\r\n    display: inline-block;\r\n}\r\n\r\n.top-sub-box #top-sub-box-balance .text-hour .sub-title,\r\n.top-sub-box #top-sub-box-annual .text-hour .sub-title,\r\n.top-sub-box #top-sub-box-previous .text-hour .sub-title {\r\n    display: inline-block;\r\n}\r\n\r\n.top-sub-box .desc {\r\n    padding: 8px 0px;\r\n    font-size: 11px;\r\n}\r\n.top-sub-box .text-hour {\r\n    font-size: 11px;\r\n    margin-top: -6px;\r\n    height: 15px;\r\n}\r\n.top-sub-box .text-day {\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n.top-sub-box span {\r\n    display: block;\r\n}\r\n.top-sub-box .textcolor-expired {\r\n    color: #e40d0d;\r\n}\r\n.top-sub-box .textcolor {\r\n    color: #000;\r\n}\r\n.top-sub-box div {\r\n    padding-top: 15px;\r\n    padding-bottom: 5px;\r\n    text-align: center;\r\n    border-radius: 12px;\r\n    margin: 0px;\r\n}\r\n\r\n.btn {\r\n    text-transform: none !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
